import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Button } from "react-bootstrap";
import ManagerNavbar from "../Layout/ManagerNavbar";
import API_BASE_URL from "../config";

export default function ManagerDocs() {
  const [documents, setDocuments] = useState([]);
  const navigate = useNavigate();

  // Check authentication
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) navigate("/");
  }, [navigate]);

  const fetchDocuments = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const res = await fetch(`${API_BASE_URL}/api/uploaddocuments/mydocuments`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.status === 401 || res.status === 403) {
        alert("Unauthorized! Please log in again.");
        navigate("/");
        return;
      }

      const data = await res.json();
      setDocuments(data);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  const handleDownload = (id, originalFileName) => {
    const token = localStorage.getItem("token");
    fetch(`${API_BASE_URL}/api/uploaddocuments/download/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to download");
        return res.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = originalFileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((err) => console.error("Download error:", err));
  };

  const handleView = (id) => {
    const token = localStorage.getItem("token");
    const viewURL = `${API_BASE_URL}/api/uploaddocuments/view/${id}`;
    const newWindow = window.open();

    if (!newWindow) {
      alert("Please allow popups for this site.");
      return;
    }

    fetch(viewURL, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load document");
        return res.blob();
      })
      .then((blob) => {
        const fileURL = URL.createObjectURL(blob);
        newWindow.location.href = fileURL;
      })
      .catch((err) => {
        console.error("View error:", err);
        newWindow.close();
        alert("Unable to open document.");
      });
  };

  const handleNewUpload = () => {
    navigate("/manageruploaddocs");
  };

  return (
    <>
      <div className="fixed-top">
        <ManagerNavbar />
      </div>

      <div
        className="d-flex flex-column"
        style={{
          height: "100vh",
          paddingTop: "120px",
          backgroundColor: "#f8f9fa",
        }}
      >
        <div className="px-4 py-3 d-flex justify-content-between align-items-center">
          <h3 className="fw-semibold text-start mb-0">My Uploaded Documents</h3>

          {/* ✅ New Upload Button */}
          <Button
            variant="primary"
            size="sm"
            className="fw-semibold"
            onClick={handleNewUpload}
          >
            New
          </Button>
        </div>

        {/* Scrollable Table Section */}
        <div
          className="flex-grow-1 overflow-auto px-4"
          style={{ maxHeight: "calc(100vh - 150px)" }}
        >
          <div className="card shadow-sm border-0 rounded-3">
            <div className="card-body p-0">
              <Table hover responsive className="mb-0 align-middle">
                <thead className="table-light text-start">
                  <tr>
                    <th style={{ width: "30%" }}>Document Type</th>
                    <th style={{ width: "40%" }}>File Name</th>
                    <th style={{ width: "30%" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {documents.length > 0 ? (
                    documents.map((doc) => (
                      <tr key={doc.id}>
                        <td className="text-start">{doc.name}</td>
                        <td className="text-start">{doc.originalFileName}</td>
                        <td className="text-start">
                          <Button
                            variant="link"
                            className="p-0 me-3 text-primary fw-semibold"
                            style={{ textDecoration: "none" }}
                            onClick={() => handleView(doc.id)}
                          >
                            View
                          </Button>
                          <Button
                            variant="link"
                            className="p-0 text-primary fw-semibold"
                            style={{ textDecoration: "none" }}
                            onClick={() => handleDownload(doc.id, doc.originalFileName)}
                          >
                            Download
                          </Button>
                        </td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center py-4">
                        No documents uploaded yet.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
